<template>
  <div class="acct-root">
    <v-menu
      offset-y
      left
      nudge-bottom="10"
      transition="slide-y-transition"
      content-class="acct-menu"
    >
      <template v-slot:activator="{ attrs, on }">
        <button type="button" class="acct-trigger" v-bind="attrs" v-on="on">
          <span class="acct-trigger__avatar">{{ initial }}</span>
          <span class="acct-trigger__meta">
            <span class="acct-trigger__name">{{ displayName }}</span>
            <span class="acct-trigger__role" v-if="appUserrole">{{ formattedRole }}</span>
          </span>
          <v-icon size="18" color="#7A8B80">mdi-chevron-down</v-icon>
        </button>
      </template>

      <v-card flat class="acct-card">
        <!-- green banner with the identity -->
        <div class="acct-head">
          <span class="acct-head__avatar">{{ initial }}</span>
          <span class="acct-head__hello">Welcome</span>
          <span class="acct-head__name">{{ displayName }}</span>
          <span class="acct-head__role" v-if="appUserrole">{{ formattedRole }}</span>
        </div>

        <div class="acct-actions">
          <router-link v-if="profilePath" :to="profilePath" class="acct-row">
            <v-icon size="19" color="#427D2D">mdi-account-outline</v-icon>
            <span class="acct-row__label">View Profile</span>
            <v-icon size="17" color="#B6C0B9">mdi-chevron-right</v-icon>
          </router-link>

          <button
            v-if="appLogin"
            type="button"
            class="acct-row acct-row--danger"
            @click="appLogout"
          >
            <v-icon size="19" color="#E5484D">mdi-logout-variant</v-icon>
            <span class="acct-row__label">Logout</span>
          </button>

          <router-link v-else to="/login" class="acct-row">
            <v-icon size="19" color="#427D2D">mdi-login-variant</v-icon>
            <span class="acct-row__label">Login</span>
          </router-link>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
      // each role reaches its profile through its own layout's route
      profilePaths: {
        admin: "/Admin/profile",
        division: "/Officers/profile",
        circle: "/Officers/profile",
        range: "/Officers/profile",
        MedicalOfficer: "/medicalOfficers/profile",
        "District Emergency Officer": "/DistrictEmergencyOfficer/profile",
      },
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userName;
    },
    appUserrole() {
      return this.$store.state.userRole;
    },
    formattedRole() {
      var role = this.appUserrole;
      if (!role) return "";
      var r = String(role).trim();
      var map = {
        medicalofficer: "Medical Officer",
        districtmedicalofficer: "District Medical Officer",
        districtemergencyofficer: "District Emergency Officer",
        disastermanagementofficer: "Disaster Management Officer",
        statemedicalofficer: "State Medical Officer",
        statedisasterofficer: "State Disaster Officer",
        statedisastermanagementofficer: "State Disaster Management Officer",
        emergencyuser: "Emergency User",
        districtmedical: "District Medical Officer"
      };

      var key = r.toLowerCase().replace(/[^a-z]/g, "");
      if (map[key]) return map[key];

      return r
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
    },
    mainRole() {
      return this.$store.state.userRole;
    },
    displayName() {
      return this.appUser || "Account";
    },
    initial() {
      return this.appUser ? this.appUser.trim().charAt(0).toUpperCase() : "A";
    },
    // roles without a profile route just get no profile link
    profilePath() {
      return this.profilePaths[this.mainRole] || null;
    },
  },
  methods: {
    appLogout() {
      // Socket.authFunction(this);
      this.$store.commit("logoutUser", true);
    },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
};
</script>
<style scoped>
/* never let a flex row (the app bar) shrink this away */
.acct-root {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  /*
   * Hug the right edge whichever way the host lays this out: `justify-content`
   * covers being a plain block in a grid cell (where a parent `text-right` has
   * no effect on a flex container), `margin-left: auto` covers being a flex
   * item in the app bar row.
   */
  justify-content: flex-end;
  margin-left: auto;
}

/* ---------- trigger in the top bar ---------- */
.acct-trigger {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 44px;
  padding: 0 10px 0 6px;
  border: 1px solid #e4eae6;
  border-radius: 24px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.acct-trigger:hover {
  border-color: #c8ddbe;
  box-shadow: 0 4px 12px rgba(66, 125, 45, 0.12);
}

.acct-trigger__avatar {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 50%;
  margin-right: 9px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: #ffffff;
  font-family: poppinssemibold;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
}

.acct-trigger__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  margin-right: 6px;
}

.acct-trigger__name {
  font-family: poppinsmedium;
  font-size: 12.5px;
  color: #1f2a24;
  line-height: 1.2;
  max-width: 128px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.acct-trigger__role {
  font-family: poppinsregular;
  font-size: 10px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #7a8b80;
  line-height: 1.3;
  max-width: 128px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ---------- dropdown ---------- */
.acct-card {
  width: 258px;
  border-radius: 16px !important;
  overflow: hidden;
}

.acct-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 16px 16px;
  background: linear-gradient(135deg, #10b981, #059669);
}

.acct-head__avatar {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  border: 2px solid rgba(255, 255, 255, 0.55);
  color: #ffffff;
  font-family: poppinssemibold;
  font-size: 22px;
  line-height: 50px;
  text-align: center;
}

.acct-head__hello {
  font-family: poppinsregular;
  font-size: 11px;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.85);
  padding-top: 10px;
}

.acct-head__name {
  font-family: poppinssemibold;
  font-size: 15px;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  word-break: break-word;
  line-height: 1.25;
  padding-top: 2px;
}

.acct-head__role {
  margin-top: 8px;
  padding: 3px 11px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.2);
  font-family: poppinsmedium;
  font-size: 10px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #ffffff;
}

.acct-actions {
  padding: 6px;
  background: #ffffff;
}

/* the global `a { color: #000 !important }` rule needs overriding here */
.acct-row {
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #2f3a33 !important;
  font-family: poppinsregular;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 0.18s ease;
}

.acct-row:hover {
  background: #f2f8ef;
}

.acct-row__label {
  flex: 1 1 auto;
  margin-left: 10px;
}

.acct-row--danger {
  color: #e5484d !important;
}

.acct-row--danger:hover {
  background: #fdf0f0;
}

/* on phones the top bar has no room for the name/role, so show just the avatar */
@media (max-width: 959px) {
  .acct-trigger {
    flex: 0 0 auto;
    height: 40px;
    padding: 0 6px 0 4px;
  }

  .acct-trigger__meta {
    display: none;
  }

  .acct-trigger__avatar {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    line-height: 30px;
    font-size: 13px;
    margin-right: 3px;
  }
}
</style>
<style>
/* the menu wrapper is rendered by Vuetify outside this component, so it cannot be scoped */
.acct-menu {
  border-radius: 16px !important;
  box-shadow: 0 14px 34px rgba(31, 42, 36, 0.16) !important;
}
</style>
